import { createContext } from 'react'

const PlayingAudioUrlContext = createContext(null)

export default PlayingAudioUrlContext
